"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DeliveryFreeColor = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DeliveryFreeColor = function DeliveryFreeColor(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#DeliveryFreeColor_svg__DeliveryFreeColor_svg__clip0_19281_92438)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F4F9E6"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "DeliveryFreeColor_svg__a",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F4F9E6"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#DeliveryFreeColor_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#97BA1E",
    stroke: "#547012",
    strokeWidth: 0.849,
    d: "M33.183 19.424h14.425v24.607H33.183z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.364 19.424h17.819v24.607H19.942l-4.578-4.544V19.424z",
    fill: "#81A11A",
    stroke: "#547012",
    strokeWidth: 0.849
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.55 27.25L32.757 19H47.42l5.614 7.998a.849.849 0 01-.695 1.336H40.633c-.83 0-1.607-.404-2.084-1.083z",
    fill: "#D4E3AC",
    stroke: "#547012",
    strokeWidth: 0.849
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.759 19H15.534l-5.6 7.999a.849.849 0 00.696 1.335H24.9c.83 0 1.609-.406 2.085-1.086L32.759 19z",
    fill: "#D4E3AC",
    stroke: "#547012",
    strokeWidth: 0.849
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 32,
    width: 6,
    height: 4,
    rx: 1.697,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.546 43.154c3.312 2.71 6.524 6.324 8.582 8.733v6.324L48.546 60c-.703-1.205-3.343-5.885-5.27-7.812-2.41-2.409-5.722-1.355-11.895-1.355-6.173 0-11.142-3.614-13.25-5.42-2.107-1.807-6.173-6.776-8.28-10.992 3.763-2.258 9.184 6.475 9.485 6.475.301 0 6.173 2.258 9.034 3.011-1.506-.903-7.077-5.571-9.636-7.83 4.216-2.258 9.485 1.356 10.389 2.259 4.37 4.37 10.69-1.506 19.423 4.818z",
    fill: "#fff",
    stroke: "#547012",
    strokeWidth: 0.849,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "DeliveryFreeColor_svg__b",
    maskUnits: "userSpaceOnUse",
    x: 7.78,
    y: 17,
    width: 52,
    height: 46,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.78 17h52v46h-52z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.42 19H15.535l-5.6 7.999a.849.849 0 00.696 1.335h5.159v8.373c-1.845-1.855-4.091-3.394-5.938-2.286 2.108 4.216 6.173 9.185 8.28 10.992 2.109 1.806 7.077 5.42 13.25 5.42 1.603 0 3.013-.071 4.264-.134 3.569-.18 5.848-.295 7.631 1.49 1.927 1.926 5.521 7.106 6.224 8.311l7.628-2.29v-6.323c-2.057-2.41-5.27-6.023-8.582-8.733a19.14 19.14 0 00-1.362-.902V28.334h5.156a.849.849 0 00.694-1.336L47.421 19z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.534 19v-1.697c-.554 0-1.073.27-1.39.724l1.39.973zm31.887 0l1.389-.975a1.697 1.697 0 00-1.39-.722V19zM9.935 26.999l1.39.973-1.39-.973zm5.854 1.335h1.696c0-.938-.76-1.697-1.696-1.697v1.697zm0 8.373l-1.204 1.196a1.697 1.697 0 002.9-1.196H15.79zM9.85 34.42l-.873-1.455a1.697 1.697 0 00-.645 2.214l1.518-.759zm8.28 10.992L17.028 46.7l1.105-1.288zm17.514 5.286l-.086-1.695.086 1.695zm7.631 1.49l1.2-1.2-1.2 1.2zM49.5 60.5l-1.466.855a1.697 1.697 0 001.954.77L49.5 60.5zm7.628-2.29l.488 1.626a1.697 1.697 0 001.21-1.625h-1.698zm0-6.323h1.697c0-.404-.144-.795-.406-1.102l-1.29 1.102zm-8.582-8.733l1.075-1.313a1.686 1.686 0 00-.08-.061l-.995 1.374zm-1.362-.902h-1.697c0 .595.312 1.147.822 1.454l.875-1.454zm0-13.918v-1.697c-.938 0-1.697.76-1.697 1.697h1.697zm5.85-1.336l-1.389.975 1.39-.975zm-37.5-6.301H47.42v-3.394H15.534v3.394zm-4.209 7.275l5.6-7.999-2.781-1.946-5.6 7.998 2.781 1.947zm-.695-1.335a.849.849 0 01.695 1.335l-2.78-1.947c-1.181 1.688.026 4.006 2.085 4.006v-3.394zm5.159 0H10.63v3.394h5.159v-3.394zm1.696 10.07v-8.373h-3.394v8.373h3.394zm-6.761-.83c.265-.16.65-.227 1.378.113.756.353 1.613 1.038 2.483 1.913l2.407-2.393c-.974-.98-2.163-1.992-3.453-2.595-1.317-.615-2.98-.898-4.561.051l1.746 2.91zm8.512 8.247c-1.928-1.653-5.856-6.439-7.868-10.462L8.333 35.18c2.204 4.409 6.407 9.56 8.694 11.521l2.21-2.577zm12.146 5.012c-5.55 0-10.124-3.279-12.146-5.012l-2.209 2.577c2.194 1.88 7.558 5.829 14.355 5.829v-3.394zm4.177-.132c-1.252.063-2.623.132-4.177.132v3.394c1.65 0 3.099-.073 4.348-.136l-.17-3.39zm8.917 1.984c-2.418-2.418-5.578-2.152-8.917-1.984l.171 3.39c3.8-.191 5.197-.155 6.346.994l2.4-2.4zm6.49 8.657c-.398-.681-1.515-2.336-2.746-4.028-1.225-1.683-2.675-3.56-3.744-4.629l-2.4 2.4c.859.859 2.17 2.536 3.4 4.226 1.222 1.68 2.253 3.218 2.558 3.741l2.932-1.71zm5.675-3.06l-7.629 2.29.976 3.25 7.628-2.289-.975-3.25zm-1.21-4.698v6.324h3.394v-6.324h-3.394zm-7.96-7.42c3.187 2.608 6.316 6.121 8.367 8.522l2.58-2.204c-2.064-2.417-5.359-6.131-8.797-8.944l-2.15 2.627zm-1.162-.761c.405.243.819.516 1.242.823l1.99-2.75a20.823 20.823 0 00-1.483-.982l-1.749 2.909zm-.822-15.372v13.918h3.394V28.334h-3.394zm6.853-1.697h-5.156v3.394h5.156v-3.394zm-.695 1.336a.849.849 0 01.695-1.336v3.394c2.06 0 3.267-2.321 2.083-4.008l-2.778 1.95zm-5.613-7.998l5.613 7.998 2.778-1.95-5.613-7.998-2.778 1.95z",
    fill: "#547012",
    mask: "url(#DeliveryFreeColor_svg__b)"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "DeliveryFreeColor_svg__DeliveryFreeColor_svg__clip0_19281_92438"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v64H0z"
  }))));
};

exports.DeliveryFreeColor = DeliveryFreeColor;
var _default = DeliveryFreeColor;
exports.default = _default;